<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Analysis Card Data Loading...
  </div>
  <info-header-card
    v-else
    :icon="analysis.icon()"
    :header="header"
    :rows="rows">
    <template v-if="sample_type" #SampleType>
      <a :href="`#/sampletypes/${sample_type.id}`" class="btn-link">
        {{ sample_type.name }}
      </a>
    </template>
    <template v-if="analyte" #Analyte>
      <a :href="`#/analytes/${analyte.id}`" class="btn-link">
        {{ analyte.name }}
      </a>
    </template>
  </info-header-card>
</template>

<script>
import AnalysisModel from "@/models/lab/AnalysisModel"
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import { getModel } from "@/shared/fetch-utils";

export default {
  name: "AnalysisCard",
  components: {
    InfoHeaderCard
  },
  props: {
    analysis: {
      type: Object,
      default: () => new AnalysisModel()
    }
  },
  data() {
    return {
      loading: true,
      measure_unit: null
    };
  },
  computed: {
    header() {
      return this.analysis.name;
    },
    analyte() {
      return this.analysis.analyte && this.analysis.getAnalyte();
    },
    sample_type() {
      return this.analyte && this.analyte.getSampleType();
    },
    rows() {
      return [
        {
          label: "Sample Type",
          value: this.sample_type && this.sample_type.name
        },
        {
          label: "Analyte",
          value: this.analyte && this.analyte.name
        },
        {
          label: "Significant Figures",
          value: `${this.analysis.significant_figures}`
        },
        {
          label: "MODUS Name",
          value: this.analysis.modus_name
        },
        {
          label: "Extraction Method",
          value: this.analysis.extraction_method
        },
        {
          label: "Measurement Method",
          value: this.analysis.measurement_method
        },
        {
          label: "Threshold Detection Limit",
          value: this.trimZeros(this.analysis.threshold_detection_limit)
        },
        {
          label: "Threshold Min Value",
          value: this.trimZeros(this.analysis.threshold_min)
        },
        {
          label: "Threshold Min Warning",
          value: this.trimZeros(this.analysis.threshold_min_warning)
        },
        {
          label: "Threshold Max Value",
          value: this.trimZeros(this.analysis.threshold_max)
        },
        {
          label: "Threshold Max Warning",
          value: this.trimZeros(this.analysis.threshold_max_warning)
        },
        {
          label: "Threshold Measure Unit",
          value: this.measure_unit
            ? this.measure_unit.name
            : "The Unit of Measurement is not specified"
        },
        {
          label: "Units of Measure",
          value: this.analysis.units
            .map(({ abbrev, name }) => `${name}(${abbrev})`)
            .join(", ")
        },
        {
          label: "Description",
          value: this.analysis.description
        }
      ];
    }
  },
  methods: {
    trimZeros(value) {
      return value != null ? parseFloat(value) : null;
    }
  },
  async created() {
    this.loading = true;

    this.analysis.threshold_unit_id &&
      (this.measure_unit = await getModel({
        model_type: "measure_unit",
        id: this.analysis.threshold_unit_id,
        message: this.$bvToast
      }));

    this.loading = false;
  }
};
</script>
